import { Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { BsGithub, BsYoutube, BsInstagram, BsLinkedin } from "react-icons/bs";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div>
        <Typography variant="h5">About Me</Typography>
        <Typography>
          Passionate Frontend Developer with a strong background in
          building engaging web applications. Skilled in JavaScript,
          TypeScript, ReactJS, and Next.js, and familiar with Node.js for a
          well-rounded development approach. Dedicated to creating
          intuitive and high-performance user experiences through clean
          and effective coding practices.
        </Typography>

        <Link to="/contact" className="footerContactBtn">
          <Typography>Contact Us</Typography>
        </Link>
      </div>
      <div>
        <Typography variant="h6">Social Media</Typography>
        <a href="https://github.com/Dheeraj-2205/" target="black">
          <BsGithub />
        </a>
        <a href="https://www.linkedin.com/in/dheeraj-joshii/" target="black">
          <BsLinkedin />
        </a>
      </div>
    </div>
  );
};

export default Footer;
